import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';

function Exercise() {
    return (
        <div>
            <h2>Add Exercise</h2>
            <FloatingLabel
                controlId="floatingInput"
                label="Exercise Name"
                className="mb-3"
            >
                <Form.Control type="text" placeholder="Exercise Name" />
            </FloatingLabel>

            <FloatingLabel
                controlId="floatingSelectGrid"
                label="Weight Type"
                className="mb-3"
            >
                <Form.Select aria-label="Floating label select example">
                    <option>Weight Type</option>
                    <option value="1">Bodyweight</option>
                    <option value="2">Weighted</option>
                    <option value="3">Hybrid</option>
                    <option value="4">Unweighted</option>
                </Form.Select>
            </FloatingLabel>

            <FloatingLabel
                controlId="floatingInput"
                label="Body Part"
                className="mb-3"
            >
                <Form.Control type="text" placeholder="Body Part" />
            </FloatingLabel>

            <Form.Group controlId="formFileMultiple" className="mb-3">
                <Form.Label>Add Infographics (Optional)</Form.Label>
                <Form.Control type="file" multiple />
            </Form.Group>

            <FloatingLabel controlId="floatingPassword" label="Upload YouTube tutorial link (Optional)" className="mb-3">
                <Form.Control type="text" placeholder="Password" />
            </FloatingLabel>

            <FloatingLabel controlId="Description" label="Description (Optional)" className="mb-3">
                <Form.Control
                as="textarea"
                placeholder="Description (Optional)"
                style={{ height: '100px' }}
                />
            </FloatingLabel>

            <Button variant="outline-info">Submit</Button>
        </div>
    );
}

export default Exercise;